import React from "react";

const bankForm = ()=> {
    return (
        <div>
            Paiement par bancaire direct
        </div>
    )
}

export default bankForm;